/* eslint-disable react/display-name */
import { BoxProps, Box } from '@quillbot/design-system';
import React, { forwardRef } from 'react';

export type IsVisibleOwnProps = {
  hideProperty?: 'display' | 'visibility';
  unmountOnHide?: boolean;
  visible: boolean;
  Component?: React.FC<any>;
};

type ComponentProps = any;

export type IsVisibleProps = IsVisibleOwnProps & ComponentProps;

const hideStyles = {
  display: {
    hide: 'none',
    show: 'flex',
  },
  visibility: {
    hide: 'hidden',
    show: 'visible',
  },
};

/**
 * It renders a Box whose `children` alter between `props.children` or `null`,
 * the box itself is not visible when box `props.visible` is `false` thus render `<Box hidden>null</Box>`
 * and when `props.visible` is `true` it renders `<Box show>{props.children}</Box>`.
 */
export const IsVisible = forwardRef((props: IsVisibleProps, ref: any) => {
  const {
    visible,
    unmountOnHide = false,
    hideProperty = 'display',
    children,
    Component = Box,
    ...componentProps
  } = props;

  let jsx = children;

  if (!visible && unmountOnHide) {
    jsx = null;
  }

  return (
    <Component
      {...componentProps}
      style={{
        [hideProperty]:
          hideStyles[hideProperty as keyof typeof hideStyles][visible ? 'show' : 'hide'],
        ...componentProps.style,
      }}
      ref={ref}
    >
      {jsx}
    </Component>
  );
});
